// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__wtqqQ","label":"Labeled_label__2niGc","divider":"Labeled_divider__1JWyx"};